import { provideHttpClient, withFetch, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { I18nModule, PageMetaService, provideConfig } from "@spartacus/core";
import { SmartEditConfig } from '@spartacus/smartedit/root';
import { AppRoutingModule, CmsPageGuard, LayoutModule, PageLayoutComponent } from "@spartacus/storefront";
import { AppComponent } from './app.component';
import { BannerModule } from "./banner/banner.module";
import { CmsCommonModule } from "./cms-common/cms-common.module";
import { CustomCreateAccountModule } from "./custom-create-account/custom-create-account.module";
import { CustomFooterModule } from "./custom-footer/custom-footer.module";
import { CustomGigyaRaasModule } from "./custom-gigya-raas/custom-gigya-raas.module";
import { CustomHeaderModule } from "./custom-header/custom-header.module";
import { DashboardModule } from "./dashboard/dashboard.module";
import { SeqirusAuthGuard, } from "./guards/seqirus-auth.guard";

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { RouterModule, Routes } from "@angular/router";
import { AsmComponentsModule } from '@spartacus/asm/components';
import { AsmRootModule } from '@spartacus/asm/root';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { QrCodeComponent } from "ng-qrcode";
import { RecaptchaFormsModule, RecaptchaModule } from "ng-recaptcha-2";
import { CookieService } from 'ngx-cookie-service';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { ToastrModule } from 'ngx-toastr';
import { AboutUkModule } from "./about-uk/about-uk-module";
import { AboutModule } from "./about/about.module";
import { AdjuvantAdvantageModule } from "./adjuvant-advantage/adjuvant-advantage.module";
import { AlfuriaModule } from "./afluria/alfuria.module";
import { CUSTOM_DATE_FORMATS } from "./all-invoices/all-invoices-left-section/all-invoices-left-section.component";
import { AllInvoicesModule } from "./all-invoices/all-invoices.module";
import { ApiFailureDialogComponent } from './api-failure-dialog/api-failure-dialog.component';
import { AsmresetpasswordModule } from "./asmresetpassword/asmresetpassword.module";
import { ClinicalSupportModule } from "./clinical-support/clinical-support.module";
import { ClinicaldataFluadModule } from "./clinicaldata-fluad/clinicaldata-fluad.module";
import { ClinicaldataFlucelvaxModule } from "./clinicaldata-flucelvax/clinicaldata-flucelvax.module";
import { CodingandbillingModule } from "./codingandbilling/codingandbilling.module";
import { ContactUsModule } from "./contact-us/contact-us.module";
import { CustomAccountModule } from "./custom-account/custom-account.module";
import { CustomAllproductsModule } from "./custom-allproducts/custom-allproducts.module";
import { CustomARREnrollmentScreenModule } from "./custom-arr-enrollment-screen/custom-arr-enrollment-screen.module";
import { CustomMyProfileModule } from "./custom-my-profile/custom-my-profile.module";
import { CustomOperationalEfficiencyModule } from "./custom-operational-efficiency/custom-operational-efficiency.module";
import { CustomPipModule } from "./custom-pip/custom-pip.module";
import { CustomStartOrderModule } from "./custom-start-order/custom-start-order.module";
import { CustomUkPublicModule } from "./custom-uk-public/custom-uk-public.module";
import { DynamiccontentModule } from "./dynamiccontent/dynamiccontent.module";
import { ApiErrorInterceptor } from "./error-interceptor/api-error-interceptor";
import { ErrorpageModule } from "./errorpage/errorpage.module";
import { FinancialDashboardUkModule } from "./financial-dashboard-uk/financial-dashboard-uk.module";
import { FinancialDashboardModule } from "./financial-dashboard/financial-dashboard.module";
import { Flu360AsmComponent } from "./flu360-asm/flu360-asm.component";
import { Flu360AsmModule } from "./flu360-asm/flu360-asm.module";
import { FluadProductModule } from "./fluad-product/fluad-product.module";
import { FluadModule } from "./fluad/fluad.module";
import { FlucelvaxCellbasedSolutionModule } from "./flucelvax-cellbased-solution/flucelvax-cellbased-solution.module";
import { FlucelvaxModule } from "./flucelvax/flucelvax.module";
import { SeqirusNotAuthGuard } from "./guards/seqirus-not-auth.guard";
import { HelpAndFaqModule } from "./help-and-faq/help-and-faq.module";
import { Influenza65PlusModule } from "./influenza-65-plus/influenza-65-plus.module";
import { InfluenzaModule } from "./influenza/influenza.module";
import { JoinAccountModule } from "./join-account/join-account.module";
import { MaterialsukModule } from "./materialsuk/materialsuk.module";
import { MobileuploadpageModule } from "./mobileuploadpage/mobileuploadpage.module";
import { MyOrdersModule } from "./my-orders/my-orders.module";
import { MyprofileUKModule } from "./myprofile-uk/myprofile-uk.module";
import { OrderSummaryUkModule } from "./order-summary-uk/order-summary-uk.module";
import { OrgLocationModule } from "./org-location/org-location.module";
import { OverviewModule } from "./overview/overview.module";
import { PaymentInfoModule } from "./payment-info/payment-info.module";
import { PaymentStatusModule } from "./payment-status/payment-status.module";
import { PrebookUserformModule } from "./prebook-userform/prebook-userform.module";
import { PrescribingInformationUkModule } from "./prescribing-information-uk/prescribing-information-uk.module";
import { ProductAqivModule } from "./product-aqiv/product-aqiv.module";
import { ProductsUkModule } from "./products-uk/products-uk-module";
import { ProfileactivationModule } from "./profileactivation/profileactivation.module";
import { RegistrationModule } from "./registration/registration.module";
import { RegistrationUkModule } from "./registration_uk/registration-uk.module";
import { ReportingUKModule } from "./reporting-uk/reporting-uk.module";
import { ReturnsThankyouPageModule } from "./returns-thankyou-page/returns-thankyou-page.module";
import { ReturnsUkModule } from "./returns-uk/returns-uk.module";
import { ReturnsUsModule } from "./returns-us/returns-us.module";
import { RweFlucelvaxModule } from "./rwe-flucelvax/rwe-flucelvax.module";
import { ScheduledPaymentModule } from "./scheduled-payment/scheduled-payment.module";
import { SessiontimeoutModule } from "./sessiontimeout/sessiontimeout.module";
import { CustomDateAdapter } from "./shared/custom-date-adapter";
import { SitemapModule } from "./sitemap/sitemap.module";
import { CDC_CONFIDENTIAL_PROVIDER } from './spartacus/services/cdc-confidential.config';
import { CdcCustomGrantInterceptor } from './spartacus/services/cdc-custom-grant.interceptor';
import { CustompagemetatitleService } from "./spartacus/services/custompagemetatitle.service";
import { GetgtmidService } from './spartacus/services/getgtmid.service';
import { SpartacusModule } from "./spartacus/spartacus.module";
import { StartOrderUKModule } from "./start-order-uk/start-order-uk.module";
import { SummaryModule } from "./summary/summary.module";
import { ToolsAndResourcesModule } from "./tools-and-resources/tools-and-resources/tools-and-resources.module";
import { UkContactUsModule } from "./uk-contact-us/uk-contact-us.module";
import { UkCookiePolicyModule } from "./uk-cookie-policy/uk-cookie-policy.module";
import { UKQivcModule } from "./uk-qivc/uk-qivc.module";
import { UkTermsAndConditionsModule } from "./uk-terms-and-conditions/uk-terms-and-conditions.module";
import { UPTAKEModule } from "./uptake/uptake.module";
import { USCookiePolicyModule } from "./us-cookie-policy/us-cookie-policy.module";
export const options: Partial<null | IConfig> | (() => Partial<IConfig>) = null;
export function initializeGtm(gtmConfigService: GetgtmidService) {

  return gtmConfigService.getGtmId();

}

const routes: Routes = [
  // { path: 'liveassist', redirectTo: '/?asm=true', pathMatch: 'full' },


  {
    path: 'liveassist',
    redirectTo: () => {
      // Hard navigation; replace to avoid keeping /liveassist in history
      window.location.replace('/?asm=true');
      // Return value won't be used since we left the SPA
      return '/';
    },
    pathMatch: 'full',
  },

  //{ path: 'login/my-account', redirectTo: '/my-account', pathMatch: 'full' },



  {
    path: 'login',
    data: { pageLabel: '/login' },
    component: PageLayoutComponent,
    canActivate: [SeqirusNotAuthGuard]
  },
  {
    path: 'my-account',
    data: { pageLabel: '/my-account' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'organisation-location',
    data: { pageLabel: '/organisation-location' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'organization-location',
    data: { pageLabel: '/organization-location' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: '',
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusNotAuthGuard]
  },
  {
    path: 'homepage',
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusNotAuthGuard]
  },
  {
    path: 'about',
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusNotAuthGuard]
  },

  {
    path: 'my-profile',
    data: { pageLabel: '/my-profile' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'changepassword',
    data: { pageLabel: '/changepassword' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'register/join-account',
    data: { pageLabel: 'register/join-account' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusNotAuthGuard]
  },
  {
    path: 'joinAccountThankYou',
    data: { pageLabel: '/joinAccountThankYou' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'profileactivation',
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusNotAuthGuard]
  },
  {
    path: 'orders',
    data: { pageLabel: '/orders' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'orders/my-orders',
    data: { pageLabel: 'orders/my-orders' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'start-order',
    data: { pageLabel: '/start-order' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'register-for-materials',
    data: { pageLabel: '/register-for-materials' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'materialOrder/my-orders',
    data: { pageLabel: 'materialOrder/my-orders' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'flu-vaccine-resource',
    data: { pageLabel: '/flu-vaccine-resource' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },

  {
    path: 'returns',
    data: { pageLabel: '/returns' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusNotAuthGuard]
  },
  {
    path: 'financial-dashboard',
    data: { pageLabel: 'financial-dashboard' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'financial-dashboard/all-invoices',
    data: { pageLabel: 'financial-dashboard/all-invoices' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'payment-information',
    data: { pageLabel: '/payment-information' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'prescribinginformation',
    data: { pageLabel: '/prescribinginformation' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'payment-status',
    data: { pageLabel: '/payment-status' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'help-and-faq',
    data: { pageLabel: '/help-and-faq' },
    component: PageLayoutComponent,
    canActivate: [SeqirusNotAuthGuard, CmsPageGuard]
  },
  {
    path: 'contact-us',
    data: { pageLabel: '/contact-us' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusNotAuthGuard]
  },
  {
    path: 'overview',
    data: { pageLabel: '/overview' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusNotAuthGuard]
  },
  {
    path: 'products',
    data: { pageLabel: '/products' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusNotAuthGuard]
  },
  {
    path: 'products/ativ',
    data: { pageLabel: '/products/ativ' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'products/tivc',
    data: { pageLabel: '/products/tivc' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'createprofile',
    data: { pageLabel: '/createprofile' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusNotAuthGuard]
  },
  {
    path: 'forgotpassword',
    data: { pageLabel: '/forgotpassword' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusNotAuthGuard]
  },



  {
    path: 'liveassist',
    component: Flu360AsmComponent,
    canActivate: [CmsPageGuard, SeqirusNotAuthGuard]
  },
  {
    path: '?asm=true',
    component: Flu360AsmComponent,
    canActivate: [CmsPageGuard, SeqirusNotAuthGuard]
  },
  {
    path: 'enrollment',
    data: { pageLabel: '/enrollment' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'public',
    data: { pageLabel: '/public' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusNotAuthGuard]
  },
  {
    path: 'uptakeaccelerator',
    data: { pageLabel: '/uptakeaccelerator' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
  {
    path: 'reportingDashboard',
    data: { pageLabel: '/reportingDashboard' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard, SeqirusAuthGuard]
  },
]
@NgModule({
  declarations: [
    AppComponent,
    ApiFailureDialogComponent,

  ],
  bootstrap: [AppComponent], imports: [BrowserAnimationsModule, CmsCommonModule,
    BrowserModule,
    StoreModule.forRoot({}),
    AppRoutingModule,
    EffectsModule.forRoot([]),
    SpartacusModule,
    CustomHeaderModule,
    LayoutModule,
    CustomFooterModule,
    BannerModule,
    CustomCreateAccountModule,
    CustomGigyaRaasModule,
    DashboardModule,
    I18nModule,
    MatDialogModule,
    MyOrdersModule,
    I18nModule,
    RouterModule.forChild(routes),
    CustomAccountModule,
    JoinAccountModule,
    CustomMyProfileModule,
    RegistrationModule,
    SummaryModule,
    FinancialDashboardModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatFormFieldModule,
    MatPaginatorModule,
    BrowserAnimationsModule,
    OrgLocationModule,
    CustomStartOrderModule,
    NgxMaskModule.forRoot(),
    RecaptchaModule,
    RecaptchaFormsModule,
    ContactUsModule,
    AllInvoicesModule,
    PaymentStatusModule,
    PaymentInfoModule,
    OverviewModule,
    CustomOperationalEfficiencyModule,
    ClinicalSupportModule,
    Influenza65PlusModule,
    StartOrderUKModule,
    CustomAllproductsModule,
    AboutModule,
    Flu360AsmModule,
    HelpAndFaqModule,
    ClinicaldataFluadModule,
    FlucelvaxModule,
    AdjuvantAdvantageModule,
    UkTermsAndConditionsModule,
    FluadModule,
    OrderSummaryUkModule,
    ProfileactivationModule,
    CustomUkPublicModule,
    ClinicaldataFlucelvaxModule,
    ReturnsUkModule,
    AboutUkModule,
    ProductsUkModule,
    AlfuriaModule,
    MyprofileUKModule,
    ErrorpageModule,
    UkContactUsModule,
    ProductAqivModule,
    UkCookiePolicyModule,
    USCookiePolicyModule,
    PrescribingInformationUkModule,
    RweFlucelvaxModule,
    InfluenzaModule,
    SessiontimeoutModule,
    UKQivcModule,
    CodingandbillingModule,
    ToolsAndResourcesModule,
    FinancialDashboardUkModule,
    FluadProductModule,
    FlucelvaxCellbasedSolutionModule,
    CustomPipModule,
    MaterialsukModule,
    UPTAKEModule,
    SitemapModule,
    AsmresetpasswordModule,
    ReturnsThankyouPageModule,
    ScheduledPaymentModule,
    ReturnsUsModule,
    DynamiccontentModule,
    MobileuploadpageModule,
    QrCodeComponent,
    CustomARREnrollmentScreenModule,
    AsmRootModule,
    AsmComponentsModule,
    ReportingUKModule,
    PrebookUserformModule,
    GoogleTagManagerModule.forRoot({
      id: initializeGtm(new GetgtmidService(document))
    }),
    RegistrationUkModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    })], providers: [CDC_CONFIDENTIAL_PROVIDER,
      provideHttpClient(withFetch(), withInterceptorsFromDi()), provideAnimationsAsync(), {
        provide: PageMetaService, useClass: CustompagemetatitleService
      }, { provide: DateAdapter, useClass: CustomDateAdapter }, { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiErrorInterceptor,
        multi: true
      },
      { provide: HTTP_INTERCEPTORS, useClass: CdcCustomGrantInterceptor, multi: true },


      // {
      //   provide: CDC_CONFIDENTIAL,
      //   useValue: {
      //     clientId: 'mobile_android',
      //     clientSecret: 'secret',
      //     tokenUrlBase: 'https://api.caah8q6d5y-seqirusuk1-d3-public.model-t.cc.commerce.ondemand.com',
      //   } as CdcConfidentialConfig,
      // },

      /* {
        provide: HTTP_INTERCEPTORS,
        useClass: ErrorInterceptor,
        multi: true
      }, */

      CookieService,
      provideConfig({
        smartEdit: {
          storefrontPreviewRoute: 'cx-preview',
          allowOrigin: 'backoffice.caah8q6d5y-seqirusuk1-d3-public.model-t.cc.commerce.ondemand.com:443',
        },
      } as SmartEditConfig),
      provideConfig({
        routing: {
          routes: {
            product: {
              paths: ['flu-vaccine-resources/:productCode'],
            }
          }
        }
      }),
      provideConfig({
        asm: {
          agentSessionTimer: {
            startingDelayInSeconds: 1800,
          },
        },

      }),
      provideHttpClient(withInterceptorsFromDi()), provideBrowserGlobalErrorListeners(), provideZoneChangeDetection({ eventCoalescing: true })]
})
export class AppModule {

}
